import { SxProps, Theme } from '@mui/material';
import { SPACING } from '../../styles';

export const loadingStateStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 200,
  p: SPACING.LARGE,
};
